var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRing5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 281,
    height: 293.319,
    viewBox: "0 0 281 293.319",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector 16",
    opacity: 0.02,
    d: "M67.876 20.8098C112.505 -6.26949 168.495 -6.26949 213.124 20.8098C254.955 46.1916 280.5 91.571 280.5 140.5V152.819C280.5 201.748 254.955 247.127 213.124 272.509C168.495 299.588 112.505 299.588 67.876 272.509C26.0449 247.127 0.5 201.748 0.5 152.819V140.5L0.504883 139.354C0.900367 90.8628 26.3717 45.9933 67.876 20.8098Z",
    stroke: "#03A388"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRing5);
export default __webpack_public_path__ + "static/media/ring5.262427d8ddf9be9d30bf2fd7a8fa66d8.svg";
export { ForwardRef as ReactComponent };